import { createContext, useContext, useState, useEffect } from "react";
import { apiFetch } from "../../hooks/apiFetch";
import { useUser } from "./UserContext";

const UserOrderContext = createContext();

export function UserOrderProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [orderData, setOrderData] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [itemsLimit, setItemsLimit] = useState(5);
    const { isLogIn } = useUser();

    useEffect(() => {
        if (!isLogIn) {
            setOrderData(null);
            setLoading(false);
            return;
        }
        async function fetchRequests() {
            try {
                const data = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/orders/my-orders${searchQuery ? "" : (`?page=${currentPage}&limit=${itemsLimit}`)}`);
                setOrderData(data);
            } catch (err) {
                setOrderData(null)
            }
            finally {
                setLoading(false);
            }
        }
        fetchRequests();
        // }
    }, [currentPage, searchQuery, itemsLimit, isLogIn]);

    return (
        <UserOrderContext.Provider
            value={{
                loading, orderData, setOrderData,
                currentPage, setCurrentPage,
                searchQuery, setSearchQuery,
                itemsLimit, setItemsLimit,
            }}>
            {children}
        </UserOrderContext.Provider>
    );
}

export function useUserOrder() {
    return useContext(UserOrderContext);
}